import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Table, Container, Button, Alert } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const AdminOrders = () => {
  const [orders, setOrders] = useState([]);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchOrders = async () => {
      document.title = '訂單管理';
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get('https://shopapi.nogi46.me/api/orders', {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        setOrders(response.data);
      } catch (error) {
        setError('無法獲取訂單，請稍後再試。');
      }
    };

    fetchOrders();
  }, []);

  const handleViewDetail = (orderNumber) => {
    navigate(`/admin/order/${orderNumber}`);
  };

  return (
    <Container>
      <h1>訂單管理</h1>
      {error && <Alert variant="danger">{error}</Alert>}
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>訂單編號</th>
            <th>用戶ID</th>
            <th>總金額</th>
            <th>創建時間</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          {orders.map((order) => (
            <tr key={order._id}>
              <td>{order.orderNumber}</td>
              <td>{order.userId}</td>
              <td>${order.totalAmount}</td>
              <td>{new Date(order.createdAt).toLocaleString()}</td>
              <td>
                <Button variant="primary" onClick={() => handleViewDetail(order.orderNumber)}>查看詳情</Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Container>
  );
};

export default AdminOrders;
